// extracted by mini-css-extract-plugin
export var bodySections = "_d7-8";
export var gray = "_d7-7";
export var green = "_d7-4";
export var iconContainer = "_d7-9";
export var iconWidgetContainer = "_d7-1";
export var phoneIcon = "_d7-2";
export var red = "_d7-5";
export var statusDot = "_d7-3";
export var widgetContainer = "_d7-0";
export var yellow = "_d7-6";